import type { SolutionGasRsoCalculator } from "../../d";

// THIS FUNCTION DOES THE ACTUAL RSO CALCULATIONS AND RETURNS ALL INTERMEDITATE VALUES FOR POTENTIAL USE IN PB AND BO CALCS
export const solutionGasRsoCalculator: SolutionGasRsoCalculator = params => {
  const {
    gasSpecificGravity,
    oilAPI,
    surfaceTemperatureF,
    tubingPressurePSIA,
    temperatureInRankine,
    reservoirPressurePSIA,
    inSituPressurePSIA,
    gasOilRatio
  } = params;
  // LOOKUP VALUES H33::H35
  const c1LessThan30 = 0.0362;
  const c2LessThan30 = 1.0937;
  const c3LessThan30 = 25.724;

  // LOOKUP VALUES I33::I35
  const c1MoreThan30 = 0.0178;
  const c2MoreThan30 = 1.187;
  const c3MoreThan30 = 23.931;

  // D33::D35 - SELECT FROM ABOVE VALUES BASED ON oilAPI
  const rsc1 = oilAPI > 30 ? c1MoreThan30 : c1LessThan30;
  const rsc2 = oilAPI > 30 ? c2MoreThan30 : c2LessThan30;
  const rsc3 = oilAPI > 30 ? c3MoreThan30 : c3LessThan30;

  // D30: =D8*(1+(5.912*10^(-5))*D7*D6*LOG(D5/114.7)) --- WHY IS THIS DEFAULT APPLIED???
  let normalizedGasSGYgn = gasSpecificGravity;
  if (tubingPressurePSIA) {
    normalizedGasSGYgn =
      gasSpecificGravity *
      (1 +
        5.912 *
          10 ** -5 *
          oilAPI *
          surfaceTemperatureF *
          Math.log10(tubingPressurePSIA / 114.7));
  }

  // D37: =D33*D30*(D3^D34)*EXP(D35*(D7/D15))
  const solutionGasRsoInSitu =
    rsc1 *
    normalizedGasSGYgn *
    inSituPressurePSIA ** rsc2 *
    Math.exp(rsc3 * (oilAPI / temperatureInRankine));

  // D39: =D33*D30*(D12^D34)*EXP(D35*(D7/D15))
  const solutionGasRsoAtReservoir =
    rsc1 *
    normalizedGasSGYgn *
    reservoirPressurePSIA ** rsc2 *
    Math.exp(rsc3 * (oilAPI / temperatureInRankine));

  return {
    rsc1,
    rsc2,
    rsc3,
    normalizedGasSGYgn,
    solutionGasRsoAtReservoir:
      solutionGasRsoAtReservoir > gasOilRatio
        ? gasOilRatio
        : solutionGasRsoAtReservoir,
    solutionGasRsoInSitu:
      solutionGasRsoInSitu > gasOilRatio ? gasOilRatio : solutionGasRsoInSitu
  };
};
